import { isBrowser } from "@p-ban/common/src/utils/CommonUtils"

import useValidBoosterCouponQuery from "../../../api/coupon/useValidBoosterCouponQuery"
import { getCouponCode } from "../../../logic/coupon/referralLink"

const useViaReferralLink = () => {
  const couponCode = isBrowser ? getCouponCode() : null
  const viaReferralLink = useValidBoosterCouponQuery(couponCode ?? "")
  return { viaReferralLink }
}

export default useViaReferralLink
